import { z } from 'zod'

import data from './data'

export const quizSchema = z.object({
  answers: z.array(z.string().regex(/[a-f]/)).length(data.length),
})

export type QuizSchema = z.infer<typeof quizSchema>
